<template>
  <div v-bind:style="containerStyle">
    <div id="pdf-buttons">
      <el-row>
        <el-col :span="12">
          <el-button type="primary" size="mini" plain class="el-icon-printer" @click="toPrintPdf">打印</el-button>
          <el-button type="primary" size="mini" plain class="el-icon-download" @click="toExportPdf">导出PDF</el-button>
        </el-col>
        <el-col :span="12">
          <div id="totalCountInfo" style="text-align: right;"></div>
        </el-col>
      </el-row>
    </div>
    <!--:height="dataListHeight"-->
    <el-table id="data-list"
              :height="dataListHeight"
              ref="multipleTable"
              :data="reportList"
              tooltip-effect="dark"
              :stripe="true"
              size="mini"
              style="width: 100%"
              @selection-change="handleSelectionChange"
              @cell-dblclick="handleDblclick">
      <el-table-column
        type="selection"
        :selectable="dataRowSelectable"
        width="35">
      </el-table-column>
      <el-table-column
        type="index"
        label="序号"
        :index="dataRowNo">
      </el-table-column>
      <el-table-column
        prop="report"
        label="样本状态"
        width="70">
        <template slot-scope="scope">
          <el-button v-if="scope.row.report.resultStatus==143 || scope.row.report.resultStatus==145 || scope.row.report.resultStatus==302" @click="viewOneReport(scope.row)" type="text" size="small">{{ formatResultStatus(scope.row.report.resultStatus) }}</el-button>
          <span v-else>{{ formatResultStatus(scope.row.report.resultStatus) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="barcode"
        label="条码号"
        width="120">
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        width="60">
      </el-table-column>
      <el-table-column
        prop="sex"
        label="性别"
        width="50"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="age"
        label="年龄"
        width="50">
      </el-table-column>
      <el-table-column
        prop="applyItem"
        label="申请项目"
        width="250" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{formatApplyItems(scope.row.applyItem)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="office"
        label="开单科室"
        width="100">
      </el-table-column>
      <el-table-column
        prop="doctor"
        label="开单医生"
        width="70">
      </el-table-column>
      <el-table-column
        prop="report_printed_count"
        label="打印状态"
        width="70">
        <template slot-scope="scope">
          {{!scope.row.report_printed_count || scope.row.report_printed_count == 0?'':'√'}}
        </template>
      </el-table-column>
      <el-table-column
        prop="paperType"
        label="纸张"
        width="50">
        <template slot-scope="scope">
          {{ formatPaperType(scope.row.paperType) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="collectTime"
        label="采样时间"
        width="140"
        :formatter="formatterDateTime">
      </el-table-column>
      <el-table-column
        prop="ckTime"
        label="送检时间"
        width="140"
        :formatter="formatterDateTime">
      </el-table-column>
      <el-table-column
        prop="testTime"
        label="检测时间"
        width="140"
        :formatter="formatterDateTime">
      </el-table-column>
      <el-table-column
        prop="auTime"
        label="审核时间"
        width="140"
        :formatter="formatterDateTime">
      </el-table-column>
      <!--<el-table-column-->
        <!--prop="audited_by_name"-->
        <!--label="审核医师"-->
        <!--width="70">-->
      <!--</el-table-column>-->
      <!--<el-table-column-->
        <!--prop="bedID"-->
        <!--label="床号"-->
        <!--width="50">-->
      <!--</el-table-column>-->
      <!--<el-table-column-->
        <!--prop="treatment_type_name"-->
        <!--label="就诊类型"-->
        <!--width="100">-->
      <!--</el-table-column>-->
      <!--<el-table-column-->
        <!--prop="userID"-->
        <!--label="受检者Id"-->
        <!--width="120">-->
      <!--</el-table-column>-->
    </el-table>
    <!--pdf报告对话框-->
    <el-dialog id="dlgPdf" title="报告单" :visible.sync="dialogPdfVisible" @open="pdfViewOpen" @close="pdfViewClose"
               top="30px"
               width="80%" center
               custom-class="dialogPdf">
      <!--v-on:printStatusUpdated="printStatusUpdated"-->
      <pdf-viewer ref="myPdfViewer" v-bind:style="dialogPdfStyle"
                  v-on:onClose="pdfViewClose"
                  :pdfBase64="pdfViewerData"></pdf-viewer>

      <span slot="footer" class="dialog-footer" style="line-height: 40px; text-align: center; padding: 2px;">
        <el-button type="primary" size="mini" plain class="iconfont icon-print" @click="printPdf">打 印</el-button>
        <el-button type="primary" size="mini" plain class="iconfont icon-close" @click="pdfViewClose">关 闭</el-button>
      </span>
    </el-dialog>
    <!---->
    <pdf-viewer ref="myPdfViewerHide" v-show="false" v-on:onPdfLoaded="onPdfLoadedHide"
                :pdfBase64="pdfViewerDataHide"></pdf-viewer>

  </div>

</template>

<script>
  import PdfViewer from '@/components/PdfViewer.vue'
  import {mapGetters, mapActions} from 'vuex';
  import {formatDate,base64ToBinary} from '../libs/common';
  import {keyCodes,dictionaryDatas} from '../commons'

  export default {
    data() {
      return {
        dialogPdfVisible: false,
        containerPadding: 20,
        pdfViewerData: '',
        selectedFormIds: '',
        pdfViewerDataHide: '',
        multipleSelection: [],
        pdfRotate: 0,
        reportList: []
      }
    },
    props: {
      myHeight: {
        type: Number
      }
    },
    computed: {
      ...mapGetters(['isLoading']),
      //列表高度
      dataListHeight: function () {
        let pdfButtonsHeight = $('#pdf-buttons').height();
        if(!pdfButtonsHeight){
          pdfButtonsHeight = 32;
        }
        if(this.myHeight > 0){
          return this.myHeight - pdfButtonsHeight - this.containerPadding * 2;
        }
      },
      containerStyle: function () {
        return {
          height: (this.myHeight - this.containerPadding * 2) + 'px',
          maxHeight: (this.myHeight - this.containerPadding * 2) + 'px',
          padding: this.containerPadding + 'px'
        }
      },
      dialogPdfStyle: function () {
        return {
          height: (this.myHeight - 120) + 'px',
          maxHeight: (this.myHeight - 120) + 'px'
        }
      },

    },
    components: {
      PdfViewer,

    },
    methods: {
      dataRowNo(index){
        return index + 1;
      },
      //根据报告状态 决定是否可以 勾选
      dataRowSelectable(row, index) {
        return row.report.resultStatus==143 || row.report.resultStatus==145 || row.report.resultStatus==302;
      },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      //勾选记录
      handleSelectionChange(val) {
        this.multipleSelection = val || [];
      },
      handleDblclick(row, column, cell, e) {
        //this.dialogPdfVisible = true;
      },
      //查看单个pdf
      viewOneReport(dataRow) {
        const _this = this;
        _this.toLoadReport(dataRow.report.ID, 'preview', (pdfBase64) => {
          _this.selectedFormIds = dataRow.report.ID;
          //_this.pdfViewerData = keyCodes.FILE_CONTENT_TYPE_PDF_BASE64 + pdfBase64;
          _this.pdfViewerData = pdfBase64;
          _this.dialogPdfVisible = true;
          _this.$store.dispatch('loaded');
        });
      },
      /**
       * 加载pdf数据
       * @param barcodes
       * @param funKey: preview-预览；downLoad-下载
       * @param onDataLoaded
       */
      toLoadReport(formIds, funKey, onSuccess) {
        const _this = this;
        _this.$store.dispatch('loading');

        const param ={
          requestFormIds: formIds,
          fun: funKey
        }
        _this.apiReport.getPdfs(_this.$store.state.userInfo.org_id, param,
          (pdfBase64)=>{
            if($.isFunction(onSuccess)){
              onSuccess(pdfBase64);
            }
          },
          _this.onFail);
      },
      //打开pdf浏览窗
      pdfViewOpen() {
        $('#dlgPdf').css({overflow: 'hidden'})
        //this.$refs.myPdfViewer.showPdf(this.pdfViewerData);
      },
      //关闭pdf对话框
      pdfViewClose() {
        this.dialogPdfVisible = false;
        this.$refs.myPdfViewer.reset();
        this.selectedFormIds = '';
        this.pdfViewerData = '';
      },
      //列表项部的打印pdf按钮
      toPrintPdf() {
        const _this = this;
        if (_this.multipleSelection.length === 0) {
          _this.$notify({
            title: '提示',
            message: '请勾择需要打印的记录',
            position: 'bottom-right'
          });
          return;
        }
        let formIdList = $.map(_this.multipleSelection, function (val, index) {
          return val.report.ID;
        });
        let formIds = formIdList.join(',');
        _this.pdfViewerDataHide = '';
        _this.$refs.myPdfViewerHide.reset();
        _this.toLoadReport(formIds, 'download', (pdfData) => {
          _this.pdfViewerDataHide = pdfData;
          //print关建字获取报告时已经更新了状态，所以这里不需要传selectedBarcodes给组件
          _this.printStatusUpdated(formIds);//在客户端更新打印状态
          _this.$store.dispatch('loaded');
        });
      },
      loadData(params) {
        const _this = this;
        _this.$store.dispatch('loading');
        _this.reportList = [];

        //let resultStatus = params.searchParams.resultStatus;
        //params.searchParams.resultStatus = null;//样本状态 不传到服务做过滤，因为前端需要统计各状态的数量，所以放在前端对返回后的数据统计
        let total137 = 0;// 已准备 统计数
        let total143 = 0;// 部分完成 统计数
        let total145 = 0;// 全部完成 统计数
        let total302 = 0;// 退单 统计数
        let total401 = 0;// 迟发 统计数

        _this.apiReport.getReportList(_this.$store.state.userInfo.org_id,params,
          (dataList) => {
            $.each(dataList, function (index, item) {
              //统计
              switch (item.report.resultStatus) {
                case "137":
                  total137 = total137 + 1;
                  break;
                case "143":
                  total143 = total143 + 1;
                  break;
                case "145":
                  total145 = total145 + 1;
                  break;
                case "302":
                  total302 = total302 + 1;
                  break;
                case "401":
                  total401 = total401 + 1;
                  break;
              }
              //过滤当前的状态显示到列表
              // if(params.searchParams.resultStatus){
              //   if(item.resultStatus == params.searchParams.resultStatus){
              //     _this.reportList.push(item);
              //   }
              // }
              // else{
              //   _this.reportList.push(item);
              // }
            });
            $('#totalCountInfo').html(`您查询的标本：共${dataList.length}个;全出${total145}个；不全${total143}个；未出${total137}个；退单${total302}个；迟发${total401}个。`);
            _this.reportList = dataList;
            _this.$store.dispatch('loaded');
          },
          _this.onFail
        );
      },
      //打印（弹窗）pdf
      printPdf() {
        const _this = this;

        if(!_this.selectedFormIds) return;

        _this.$store.dispatch('loading');
        _this.$refs.myPdfViewer.print();

        _this.apiReport.updatePrintCount(_this.$store.state.userInfo.org_id,
          {formIds: _this.selectedFormIds},
          ()=>{
            _this.printStatusUpdated(_this.selectedFormIds);
            _this.$store.dispatch('loaded');
          }, _this.onFail
        );

      },
      //打印状态更新成功后（弹窗打印完成后的回调）
      printStatusUpdated(formIds) {
        const _this = this;
        if (!formIds) return;
        let formIdList = formIds.split(',');//列表
        //遍历、更新打印状态
        $.each(formIdList, function (index, value) {
          $.each(_this.reportList, function (indexReport, itemReport) {
            if (itemReport.report.ID == value) {
              itemReport.report_printed_count = 1;
              return;
            }
          })
        })
      },
      //导出pdf
      toExportPdf() {
        const _this = this;
        if (_this.multipleSelection.length === 0) {
          _this.$notify({
            title: '提示',
            message: '请勾择需要导出的记录',
            position: 'bottom-right'
          });
          return;
        }

        let fileDownload = require('js-file-download');
        //单个文件下载
        $.each(_this.multipleSelection, function (index, dataRow) {
          if (!dataRow.report.ID) {
            return;
          }
          _this.toLoadReport(dataRow.report.ID, 'download', (pdfData) => {
            const pafFile = base64ToBinary(keyCodes.FILE_CONTENT_TYPE_PDF_BASE64 + pdfData);
            fileDownload(pafFile, formatDate(new Date(), 'yyyyMMddhhmmss') + '-' + dataRow.name + '-' + dataRow.barcode + '.pdf');
            _this.printStatusUpdated(dataRow.report.ID);
            _this.$store.dispatch('loaded');
          });
        });
      },
      /**
       * 用于列表顶部打印pdf控件，加载完成时解发打印
       */
      onPdfLoadedHide() {
        const _this = this;
        setTimeout(function () {
          _this.$refs.myPdfViewerHide.print();
        }, 100);
      },
      // /**
      //  * 切换pdf方向
      //  */
      // switchRotation() {
      //   let pdfRotate = this.$store.state.pdfRotate == 0 ? 90 : 0;
      //   this.$store.dispatch('setPdfRotate', pdfRotate);
      // },
      //失败处理方法
      onFail(error){
        const _this = this;

        _this.$notify({
          title: '错误',
          message: error.message,
          type: 'error',
          position: 'bottom-right'
        });
        _this.$store.dispatch('loaded');
      },
      //格式化结果状态列
      formatResultStatus(id) {
        let text = '';
        $.each(dictionaryDatas.specStatusList, function (index, item) {
          if(item.id == id){
            text= item.text;
            return false;
          }
        })
        return text;
      },
      //格式化项目列
      formatApplyItems(value) {
        let s = "";
        if (value == null || value.length == 0) return "";
        s = value.replace(/&/g, ">");
        s = s.replace(/</g, "&lt;");
        s = s.replace(/>/g, "&gt;");
        s = s.replace(/\s/g, "&nbsp;");
        s = s.replace(/\n/g, "<br>");
        return s ;
      },
      //格式化纸张类型
      formatPaperType(value){
        let text = '';
        $.each(dictionaryDatas.paperSizeList, function (index, item) {
          if(item.id == value){
            text= item.text;
            return false;
          }
        })
        return text;
      },
      formatterDateTime(row, column, cellValue, index){
        return cellValue ? formatDate(new Date(cellValue), 'yyyy-MM-dd hh:mm:ss'): "";
      },
      onresize(){

      },
    },
    watch: {},
    mounted() {

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ReportList.vue